import {
  Button,
  CircularProgress,
  Typography,
  makeStyles,
} from "@material-ui/core";
import React, { Fragment, useCallback, useEffect, useState } from "react";
import { useMutation, useTranslate } from "ra-core";

import { APP_URL } from "../../config";

const useStyles = makeStyles((theme) => ({
  fixedMultiline: {
    overflow: "hidden",
    "text-overflow": "ellipsis",
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    whiteSpace: "break-spaces",
    WebkitLineClamp: 3,
    lineHeight: "16px",
    fontSize: "14px",
  },
  withPadding: {
    padding: theme.spacing(1),
  },
}));
const ProtocolButton = ({ ...props }) => {
  const classes = useStyles();
  const translate = useTranslate();
  const [record, setRecord] = useState(props.record);
  const [protocol, { data, loading }] = useMutation({
    type: "post",
    resource: "projects/protocol",
    payload: { id: record.record_id, tid: record.id },
  });
  const handleClick = useCallback(() => {
    setRecord({ ...record, protocol_error: null });
    protocol();
  }, [record, protocol]);
  useEffect(() => {
    if (data === null) {
      return;
    }
    setRecord(data.data);
  }, [data]);

  return (
    <Fragment>
      {record.protocol_status !== "success" && (
        <Button
          size="small"
          color="primary"
          variant="contained"
          onClick={handleClick}
          endIcon={loading ? <CircularProgress size={20} /> : null}
          disabled={loading || record.notes === null}
        >
          {translate("resources.projects.buttons.protocol")}
        </Button>
      )}
      {record.protocol_status === "success" && (
        <Button
          component="a"
          target="_blank"
          variant="outlined"
          className={classes.fixedMultiline}
          href={`${APP_URL}${record.protocol_filename}`}
        >
          {record.protocol_code.split("/").join(" / ")}
        </Button>
      )}
      {record.protocol_status === "error" && (
        <Typography
          className={[classes.fixedMultiline, classes.withPadding]}
          variant="body2"
          color="error"
        >
          {record.protocol_error}
        </Typography>
      )}
    </Fragment>
  );
};
export default ProtocolButton;
